import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["content", "button"]
  static values = {
    url: String
  }

  connect() {
    if (this.hasButtonTarget) {
      this.buttonTarget.addEventListener("click", () => this.handleButtonClick())
    } else {
      this.loadContent()
    }
  }

  handleButtonClick() {
    const spinner = document.createElement("div")
    spinner.className = "async-custom-spinner"
    this.buttonTarget.replaceWith(spinner)
    this.loadContent()
  }

  async loadContent() {
    try {
      const response = await fetch(this.urlValue)
      const html = await response.text()
      this.contentTarget.innerHTML = html
    } catch (error) {
      console.error("Erro ao carregar conteúdo:", error)
      this.contentTarget.innerHTML = `
        <div class="has-text-centered">
          <p class="subtitle has-text-danger is-6">
            Erro ao carregar. Por favor, tente novamente.
          </p>
        </div>
      `
    }
  }
}
